import Vue from 'vue'
import Router from 'vue-router'
import register from '../views/loginPage/register'
import loginPage from '../views/loginPage/loginPage'
import homePage from '../views/home/home'
import trainDetails from '../views/xwzy/trainDetails.vue'
import department from '../views/xwzy/department.vue'
import journeyReport from '../views/journeyReport/journeyReport.vue'
import AIFV from '../views/AIFV/AIFV.vue'
import AIFVONEPAGE from '../views/AIFV/AIFVONEPAGE.vue'
import courserDetailsXwzy from '../views/course/courserDetailsXwzy.vue'
import trainNone from '../views/training/trainNoneData.vue'
// 后台配置路由，暂时先手写
import pcInfos from '@/views/home/pcInfos'
import followPage from '@/views/loginPage/followPage.vue'
import ssotempPage from '@/views/loginPage/ssotempPage'
import articleDetails from '@/views/article/articleDetails'
import longTimeLogin from '@/views/loginPage/longTimeLogin'
import agreeDetailPage from '@/views/person/agreeDetailPage.vue'
import fontBase from '@/views/person/fontBase.vue'
import agreeList from '@/views/person/agreeList.vue'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) { return originalPush.call(this, location, onResolve, onReject) }
  return originalPush.call(this, location).catch(err => err)
}
export const constantRouterMap = [
  { path: '/', redirect: '/loginPage' },
  {
    path: '/register',
    name: '注册页',
    meta: {
      moduleName: '注册'
    },
    component: register
  },
  {
    path: '/loginVerification',
    name: '登录校验',
    meta: {
      moduleName: '登录校验'
    },
    component: () => import('../views/loginPage/loginVerification.vue')
  },
  {
    path: '/linkExpired',
    name: '链接失效',
    meta: {
      moduleName: '链接失效'
    },
    component: () => import('../views/loginPage/linkExpired.vue')
  },
  {
    path: '/appealPage',
    name: '申诉页',
    meta: {
      moduleName: '申诉页'
    },
    component: () => import('../views/loginPage/appealPage.vue')
  },
  {
    path: '/loginPage',
    name: '登录页',
    meta: {
      moduleName: '登录'
    },
    component: loginPage
  },
  {
    path: '/followPage',
    name: '关注二维码',
    meta: {
      moduleName: '关注二维码'
    },
    component: followPage
  },
  {
    path: '/home',
    name: '首页',
    meta: {
      moduleName: '首页'
    },
    component: homePage
  },
  {
    path: '/trainNone',
    name: '训练营判空',
    meta: {
      moduleName: '训练营'
    },
    component: trainNone
  },
  {
    path: '/xwzy/trainDetails',
    name: '行稳致远',
    meta: {
      moduleName: '行稳致远'
    },
    component: trainDetails
  },
  {
    path: '/xwzy/articleDetails',
    name: '行稳致远 - 文献详情',
    meta: {
      moduleName: '行稳致远'
    },
    component: articleDetails
  },
  {
    path: '/xwzy/department',
    name: '大主任',
    meta: {
      moduleName: '行稳致远'
    },
    component: department
  },
  {
    path: '/xwzy/journeyReport',
    name: '旅程报告',
    meta: {
      moduleName: '行稳致远'
    },
    component: journeyReport
  },
  {
    path: '/xwzy/AIFV',
    name: 'AIFVonepage',
    meta: {
      moduleName: 'AIFV'
    },
    component: AIFV
  },
  {
    path: '/AIFVONEPAGE',
    name: 'AIFVonepage单页',
    meta: {
      moduleName: 'AIFV'
    },
    component: AIFVONEPAGE
  },
  {
    path: '/courserDetailsXwzy',
    name: '课程详情',
    meta: {
      moduleName: '行稳致远'
    },
    component: courserDetailsXwzy
  },
  {
    path: '/pcInfos',
    name: 'iEP-中国电生理术者充电站',
    meta: {
      moduleName: 'iEP-中国电生理术者充电站'
    },
    component: pcInfos
  },
  {
    path: '/sso/tempPage',
    name: 'sso登陆中转页',
    meta: {
      moduleName: 'sso登陆中转页'
    },
    component: ssotempPage
  },
  {
    path: '/longTimeLogin',
    name: '登录',
    meta: {
      moduleName: '登录'
    },
    component: longTimeLogin
  },
  {
    path: '/agreeDetailPage',
    name: '协议详情',
    meta: {
      moduleName: '协议详情'
    },
    component: agreeDetailPage
  },
  {
    path: '/agreeList',
    name: '用户授权',
    meta: {
      moduleName: '用户授权'
    },
    component: agreeList
  },
  {
    path: '/fontBase',
    name: '字体许可证',
    meta: {
      moduleName: '字体许可证'
    },
    component: fontBase
  },
  {
    path: '/JJMC_ECGenius',
    name: '室早心电图',
    meta: { moduleName: 'JJMC_ECGenius' },
    component: () => import('../views/JJMC_ECGenius/index.vue'),
  },
  {
    path: '/informationDisplay',
    name: '用户展示',
    meta: { moduleName: '用户展示' },
    component: () => import('../views/informationDisplay/index.vue'),
  },
  {
    path: '/filePreview',
    name: '文件预览',
    meta: { moduleName: '文件预览' },
    component: () => import('../views/pfa/filePreview.vue'),
  },
]
export default new Router({
  routes: constantRouterMap,
  mode: 'history',
  base: process.env.BASE_URL
})



// WEBPACK FOOTER //
// ./src/router/index.js